import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { BehaviorSubject, Observable } from 'rxjs';
import { JobType } from './job-type.model';

export interface IJobTypeService {
  allJobTypes$: Observable<JobType[]>;
}

@Injectable({
  providedIn: 'root',
})
export class JobTypeService implements IJobTypeService {
  private http = inject(HttpClient);

  private url = `${inject(RUNTIME_CONFIG).apiUrl}/contracts/job-types`;
  private _allJobTypesSubject = new BehaviorSubject<JobType[]>([]);

  constructor() {
    this.loadAllJobTypes();
  }

  get allJobTypes$(): Observable<JobType[]> {
    return this._allJobTypesSubject.asObservable();
  }

  private loadAllJobTypes() {
    this.http.get<JobType[]>(this.url).subscribe((jobTypes) => {
      this._allJobTypesSubject.next(jobTypes);
    });
  }
}
